module.exports = __webpack_public_path__ + "img/arrow-down.e23e7dea.svg";